export function transformContentfulData(components: any[] = []) {
  const transformedData: any = {};
  components.forEach((item: any) => {
    const key = item.fields.name;
    delete item.fields.name;
    transformedData[key] = item.fields;
  });
  return transformedData;
}